import { render, staticRenderFns } from "./template.vue?vue&type=template&id=18f2d75a&scoped=true&"
import script from "./template.vue?vue&type=script&lang=ts&"
export * from "./template.vue?vue&type=script&lang=ts&"
import style0 from "./template.vue?vue&type=style&index=0&id=18f2d75a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2d75a",
  null
  
)

export default component.exports